function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.004 83.8h-.315a13.184 13.184 0 01-2.185-.494c-3.346-.665-9.605-1.798-16.574-3.912-8.274-2.536-11.25-6.295-11.395-6.412-1.987-2.383-2.473-6.493-1.052-10.845a106.369 106.369 0 015.261-12.006L49.597.364m4.538 87.347c-4.973 7.077-13.49 12.545-24.092 15.405a63.463 63.463 0 01-16.44 2.185A55.756 55.756 0 01.52 103.808m59.323-15.584c-4.407 23.004-33.184 34.047-33.472 34.155m39.01-31.61c1.052 21.007-13.409 30.279-13.553 30.369"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.108 76.854c6.67-1.546 11.252-1.349 13.743.591 3.737 2.91 5.07 8.584 9.596 9.372 4.527.789 12.198-.543 12.543-11.49.23-7.3-3.533-12.884-11.288-16.756"
}));

function SvgRoomSmell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 123,
    viewBox: "0 0 84 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSmell);
export default __webpack_public_path__ + "static/media/RoomSmell.511f0583.svg";
export { ForwardRef as ReactComponent };